import React from 'react';
import { Alert, Snackbar, Button, Box } from '@mui/material';
import { ErrorOutline, Refresh } from '@mui/icons-material';

export const ApiErrorHandler = ({
  error,
  onRetry,
  onDismiss,
  show = false
}) => {
  const [open, setOpen] = React.useState(show);

  React.useEffect(() => {
    setOpen(!!error);
  }, [error]);

  const handleClose = () => {
    setOpen(false);
    if (onDismiss) onDismiss();
  };

  const handleRetry = () => {
    if (onRetry) onRetry();
    setOpen(false);
  };

  if (!error) return null;

  const getErrorMessage = (error) => {
    if (typeof error === 'string') return error;

    if (error.response) {
      // Erro de resposta HTTP
      const status = error.response.status;
      const message = error.response.data?.message || error.response.data?.error;

      switch (status) {
        case 401:
          return 'Sessão expirada. Faça login novamente.';
        case 403:
          return 'Você não tem permissão para esta ação.';
        case 404:
          return 'Recurso não encontrado.';
        case 500:
          return 'Erro interno do servidor. Tente novamente mais tarde.';
        case 503:
          return 'Serviço temporariamente indisponível.';
        default:
          return message || `Erro ${status}: Algo deu errado.`;
      }
    }

    if (error.request) {
      // Erro de rede
      return 'Problema de conexão. Verifique sua internet e tente novamente.';
    }

    // Outros erros
    return error.message || 'Ocorreu um erro inesperado.';
  };

  const getSeverity = (error) => {
    if (error.response) {
      const status = error.response.status;
      if (status >= 500) return 'error';
      if (status >= 400) return 'warning';
    }
    return 'error';
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={getSeverity(error)}
        sx={{
          width: '100%',
          '& .MuiAlert-message': {
            width: '100%'
          }
        }}
        action={
          onRetry && (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Button
                color="inherit"
                size="small"
                startIcon={<Refresh />}
                onClick={handleRetry}
                sx={{
                  minWidth: 'auto',
                  textTransform: 'none'
                }}
              >
                Tentar Novamente
              </Button>
            </Box>
          )
        }
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ErrorOutline fontSize="small" />
          {getErrorMessage(error)}
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default ApiErrorHandler;
